import React, {useEffect, useState} from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import AsyncPaginate from "react-select-async-paginate";
import get from "lodash/get";

import {api, queryBuilder} from "@/services";

const load = async (
    search,
    prevOptions,
    {page},
    url,
    filterParams,
    loadOptionsParams,
    loadOptionsKey
) => {
    const {data} = await api.request.get(
        queryBuilder(url, {
            page: page,
            filter: filterParams,
            ...loadOptionsParams(search),
        })
    );

    return {
        options: loadOptionsKey
            ? typeof loadOptionsKey === "function"
                ? loadOptionsKey(data)
                : get(data, loadOptionsKey, [])
            : data,
        hasMore: get(data, "current_page", 1) < get(data, "last_page", 1),
        additional: {page: get(data, "current_page", 1) + 1},
    };
};

const NewAsyncSelectS1 = ({
                              disableOptions,
                              className,
                              label,
                              isMulti,
                              loadOptionsKey,
                              placeholder,
                              options,
                              field,
                              optionLabel,
                              optionValue,
                              size,
                              styles,
                              form: {errors, setFieldValue, setFieldTouched, touched},
                              isDisabled,
                              isSearchable,
                              menuPlacement,
                              loadOptionsUrl,
                              isClearable = false,
                              loadOptionsParams = () => {
                              },
                              handleChange = () => {
                              },
                              filterParams = {},
                              canUpdate,
                              classNamePrefix = "rs",
                          }) => {
    const classes = cx(
        "form-field",
        touched[field.name] && errors[field.name] && "form-field--error",
        field.value && "form-field--active",
        className
    );

    const getSizeHeight = () => {
        switch (size) {
            case "default":
                return "48px";
            case "small":
                return "36px";
            case "very-small":
                return "28px";
            case "large":
                return "52px"; 
            default:
                return "48px";
        }
    };
    const getSizeRadius = () => {
        switch (size) {
            case "default":
                return "10px";
            case "small":
                return "5px";
            case "very-small":
                return "5px";
            case "large":
                return "15px";
            default:
                return "10px";
        }
    };
    const getSizeFont = () => {
        switch (size) {
            case "default":
                return "16px";
            case "small":
                return "14px";
            case "very-small":
                return "10px";
            case "large":
                return "16px";
            default:
                return "16px";
        }
    };

    const customStyle = {
        container: (base) => ({
            ...base,
            minHeight: getSizeHeight(),
            minWidth: "150px",
        }),
        control: (base, state) => ({
            ...base,
            cursor: "pointer",
            minHeight: getSizeHeight(),
            height: getSizeHeight(),
            backgroundColor: "#ffffff",
            borderRadius: getSizeRadius(),
            border: touched[field.name] && errors[field.name]
                ? "2px solid #ff4d4f"
                : state.isFocused
                    ? "2px solid #60a5fa"
                    : "2px solid #d1d5db",

            boxShadow: state.isFocused
                ? "0 0 0 4px rgba(96, 165, 250, 0.2)"
                : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",

            transition: "all 0.3s ease",
            ":hover": {
                borderColor: state.isFocused ? "#60a5fa" : "#93c5fd",
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: size === 'very-small' ? '0 10px' : "0 16px",
            height: getSizeHeight(),
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: getSizeFont(),
        }),
        input: (base) => ({
            ...base,
            fontSize: getSizeFont(),
        }),
        singleValue: (base) => ({
            ...base,
            color: "#1f2937",
            fontSize: getSizeFont(),
        }),
        indicatorSeparator: (base) => ({...base, display: "none"}),
        dropdownIndicator: (base, state) => ({
            ...base,
            color: "#9ca3af",
            paddingRight: "12px",
            transition: "transform 0.3s ease",
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
        }),
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            borderRadius: "12px",
            marginTop: "8px",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            zIndex: 9999,
            backgroundColor: "#fff",
            position: 'absolute',
        }),
        menuList: (base) => ({
            ...base,
            backgroundColor: "#fff",
            maxHeight: "180px",
            overflowY: "auto",
            userSelect: "none",
        }),
        option: (base, state) => ({
            ...base,
            fontSize: getSizeFont(),
            padding: "12px 16px",
            cursor: "pointer",
            backgroundColor: state.isSelected
                ? "#3b82f6"
                : state.isFocused
                    ? "#f3f4f6" 
                    : "transparent",
            color: state.isSelected ? "#ffffff" : "#374151",
            ":active": {
                backgroundColor: "#e5e7eb",
            },
        }),
    };
    
    const [isVisible, setVisible] = useState(true);
    useEffect(() => {
        setVisible(function (prev) {
            return !prev;
        });
        setTimeout(function () {
            setVisible(function (prev) {
                return !prev;
            });
        }, 0);
    }, [canUpdate]);

    return (
        <div className={classes}>
            {label ? <div className="form-field__label">{label}</div> : null}

            {isVisible ? (
                <div className="pos-relative">
                    <AsyncPaginate
                        id={field.name}
                        name={field.name}
                        debounceTimeout={300}
                        isDisabled={isDisabled}
                        value={field.value}
                        isClearable={isClearable}
                        isSearchable={!!isSearchable}
                        isMulti={!!isMulti}
                        options={options}
                        placeholder={placeholder}
                        menuPlacement={menuPlacement}
                        
                        menuPortalTarget={
                            typeof document !== "undefined" ? document.body : null
                        }
                        menuPosition="fixed"
                        styles={styles || customStyle}
                        classNamePrefix={classNamePrefix}
                        onChange={(option) => {
                            setFieldValue(field.name, option);
                            handleChange(option);
                        }}
                        onBlur={() => setFieldTouched(field.name, true)}
                        
                        getOptionLabel={(opt) =>
                            typeof optionLabel === "function"
                                ? optionLabel(opt)
                                : opt[optionLabel]
                        }
                        getOptionValue={(opt) =>
                            typeof optionValue === "function"
                                ? optionValue(opt)
                                : opt[optionValue]
                        }
                        getValue={(opt) => opt[optionValue]}
                        
                        additional={{page: 1}}
                        loadOptions={(search, prev, {page}) =>
                            load(
                                search,
                                prev,
                                {page: page},
                                loadOptionsUrl,
                                filterParams,
                                loadOptionsParams,
                                loadOptionsKey
                            )
                        }
                        
                        isOptionDisabled={(opt) =>
                            (disableOptions || [])
                                .reduce(function (prev, curr) {
                                    prev.push(curr.id);
                                    return prev;
                                }, [])
                                .includes(opt.id)
                        }
                        components={{
                            DropdownIndicator: () => (
                                <div style={{paddingRight: '12px', display: 'flex', alignItems: 'center'}}>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#9ca3af"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </div>
                            )
                        }}
                    />

                    {touched[field.name] && errors[field.name] ? (
                        <div className="form-field__error">
                            <span>{errors[field.name]}</span>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div className="pos-relative" style={{minHeight: getSizeHeight()}}/>
            )}
        </div>
    );
};

NewAsyncSelectS1.propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    optionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    optionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    isSearchable: PropTypes.bool,
    isDisabled: PropTypes.bool,
    menuPlacement: PropTypes.string,
    size: PropTypes.oneOf(["default", "large", "small", 'very-small']),
    loadOptionsKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
        .isRequired,
    classNamePrefix: PropTypes.string,
};

NewAsyncSelectS1.defaultProps = {
    title: "",
    className: null,
    optionValue: "id",
    optionLabel: "title",
    isSearchable: false,
    isDisabled: false,
    menuPlacement: "bottom",
    disableOptions: [],
    loadOptionsKey: "data",
    size: "default",
    classNamePrefix: "rs",
};

export default NewAsyncSelectS1;
